import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  organization_sessions: [],
  organization_sessions_view: {},
  organization_revisions: [],
  organization_revisions_view: {},
  organization_create_revisions: [],
  organization_create_revisions_view: {},
  organization_update_revisions: [],
  organization_update_revisions_view: {},
  organization_destroy_revisions: [],
  organization_destroy_revisions_view: {},
  user_revisions: [],
  user_revisions_view: {},
  user_actions: [],
  user_actions_view: {},
  user_revisions_error: {},
  change_audit: {},
  user_list: [],
  user_list_view: {},
  broadcasts: {},
  join_requests: {},
  simple_join_requests: {},
  packets: {},
  network_statistics: {},
  gateway_statistics: {},
  join_requests_quantities: {},
  packets_quantities: {},
  stats: {},
  crc_errors: {},
  missed_packets: {},
  search_results: {},
  system_summary: {},
  licenses_object: {},
  organization_schedule_provisioning: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/organizationStates/store/index.js